import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Division, DivisionStatus, Subdivision, SubdivisionStatus } from 'src/shared/api';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: 'rpshared-division-upload-dialog',
	templateUrl: './division-upload-dialog.component.html',
	styleUrls: ['./division-upload-dialog.component.css'],
})
export class DivisionUploadDialogComponent extends SelfDestruct {
	form: FormGroup;
	file: any;
	divisions: FormGroup[] = [];

	constructor(
		@Inject(MAT_DIALOG_DATA)
		@Optional()
		readonly data: {
			divisions: FormGroup[],
		},
		private readonly fb: FormBuilder,
		private readonly dialog: MatDialogRef<DivisionUploadDialogComponent>,
		private readonly snackbar: MatSnackBar,

	) {
		super();
		this.form = fb.group({ divisions: this.fb.array([]) });
		this.divisions = this.data.divisions;
		
	}
		fileBrowseHandler(file: any) {
			if(file[0].type != "text/csv"){
				this.snackbar.open("Invalid file type. Please upload a .csv file.")
				this.close();
				return
			}
			this.file = file[0];
		}

		uploadDocument() { 
			if(this.file == null){
				this.snackbar.open("No file provided to upload.")
				this.close(); 
				return
			}
			let fileReader = new FileReader();    
			fileReader.onload = () => { 
				let content = fileReader.result as string;
				let fileJson = this.csvToJson(content)
				if(fileJson){
					this.addNewDivisionsFromJson(fileJson)
				}
			}
			fileReader.readAsText(this.file);
		}

		csvToJson(csv: string){
			var lines = csv.split("\n");
			var result = [];
			var headers = lines[0].split(",");
			if(headers[0] != "AREA_NAME" || headers[1] != "SBDV_NAME" ){
				this.snackbar.open("Error: File has invalid headers for divisions.")
				this.close()
				return null
			}
			for (var i = 1; i < lines.length; i++) {
				var obj: any = {};
				var currentline = lines[i].split(",");
				for (var j = 0; j < headers.length; j++) {
					obj[headers[j]] = currentline[j];
				}
				result.push(obj);
			}
			return result;
		}

		addNewDivisionsFromJson(excelJson: any[]){
			for (const item of excelJson){
				if(item.AREA_NAME != ""){
					var currentDivision = this.divisions.find(x => x.value.name === item.AREA_NAME); 
					if(currentDivision){
						var currentSbdv = currentDivision.value.subdivisions.find((y: { name: any; }) => y.name === item.SBDV_NAME);
						if (!currentSbdv){
							var newSbdv = this.createSubdivision(item.SBDV_NAME); 
							currentDivision.value.subdivisions.push(newSbdv); 
						}
					} 
					else {
						var newDivision = this.createDivision(item);
						this.divisions.push(
							this.fb.group({
								id: newDivision.id,
								name: newDivision.name,
								status: newDivision.status,
								isAssignedToAJob: newDivision.isAssignedToAJob,
								subdivisions: [newDivision.subdivisions],
							})
						)
					}
				}
			}
			this.dialog.close(this.divisions);
		}

		createDivision(item: any){ 
			var division: Division = {};
			var sbdvs: Subdivision[] = [];

			var sbdv = this.createSubdivision(item.SBDV_NAME);
			sbdvs.push(sbdv);
			division.name = item.AREA_NAME;
			division.subdivisions = sbdvs;
			division.status = DivisionStatus.Active;
			return division;
		}

		createSubdivision(name: string){
			var sbdv: Subdivision = {};
			sbdv.name = name;
			sbdv.status = SubdivisionStatus.Active;
			return sbdv;
		}

		close(){
			this.dialog.close()
		}
}
